var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiderProfileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13232_155165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 42C35.0457 42 44 33.0457 44 22C44 10.9543 35.0457 2 24 2C12.9543 2 4 10.9543 4 22C4 33.0457 12.9543 42 24 42Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8991 21.8999C25.0303 21.8999 26.136 21.5645 27.0766 20.9361C28.0171 20.3076 28.7501 19.4144 29.183 18.3694C29.6159 17.3243 29.7291 16.1744 29.5085 15.0649C29.2878 13.9555 28.7431 12.9364 27.9432 12.1366C27.1434 11.3367 26.1243 10.792 25.0149 10.5714C23.9055 10.3507 22.7555 10.4639 21.7105 10.8968C20.6654 11.3297 19.7722 12.0627 19.1438 13.0033C18.5153 13.9438 18.1799 15.0495 18.1799 16.1807C18.1797 16.9318 18.3275 17.6756 18.6148 18.3696C18.9022 19.0636 19.3234 19.6941 19.8546 20.2253C20.3857 20.7564 21.0162 21.1777 21.7102 21.465C22.4042 21.7523 23.148 21.9001 23.8991 21.8999ZM23.8991 24.7592C20.0822 24.7599 12.4614 26.6753 12.4614 30.4784V33.3376H35.3376V30.4784C35.3376 26.6753 27.7168 24.7599 23.8991 24.7599V24.7592Z",
    fill: "#492897"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13232_155165",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 0 0.768627 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13232_155165"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13232_155165",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiderProfileLogo);
export default __webpack_public_path__ + "static/media/rider-profile-logo.016df6ac7cfd1ac12d475487d834e627.svg";
export { ForwardRef as ReactComponent };